import _ from 'lodash';

import {
  AthenaTableGQLType,
  AthenaTablePropertyTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

const stringIcon = 'font-case';
const numberIcon = 'hashtag';
export const athenaDataTypeToIcon: Record<
  AthenaTablePropertyTypeGQLType,
  string
> = {
  boolean: 'check',
  tinyint: numberIcon,
  smallint: numberIcon,
  int: numberIcon,
  integer: numberIcon,
  bigint: numberIcon,
  double: numberIcon,
  float: numberIcon,
  decimal: numberIcon,
  char: 'font-case',
  varchar: stringIcon,
  string: stringIcon,
  binary: 'binary',
  date: 'calendar-days',
  timestamp: 'clock',
  array: 'brackets-square',
  map: 'brackets-curly',
  struct: 'brackets-curly',
};

export const filterAthenaTablesForCreditFacility = ({
  athenaTables,
  creditFacilitySlug,
}: {
  athenaTables: AthenaTableGQLType[];
  creditFacilitySlug: string;
}) => {
  return _.filter(athenaTables, (athenaTable) => {
    const athenaTableNameParts = athenaTable.tableName.split('_');
    const athenaTableNameSuffix =
      athenaTableNameParts[athenaTableNameParts.length - 1];

    return _.toLower(athenaTableNameSuffix) === _.toLower(creditFacilitySlug);
  });
};
